<template><div class="main">
  <sticky-bar @back="$router.push('/')" :loading="!unit">
    {{ unit ? unit.name : 'Loading...' }}
    <small><template v-if="!$route.meta.noPrefix">Details &mdash; </template>{{ $route.meta.title }}</small>
    <template #more>
      <div class="more-menu">
        <router-link :to="`/u/${id}/s`">Status</router-link>
        <router-link :to="`/u/${id}/f`" v-if="fleet && !fleet.restricted">Files</router-link>
        <!--
        <router-link :to="`/u/${id}/t`">Table</router-link>
        -->
        <router-link :to="`/u/${id}/m`">Map</router-link>
        <router-link :to="`/u/${id}/r`" v-if="fleet && !fleet.restricted">Reports</router-link>
        <router-link :to="`/u/${id}/v`" v-if="fleet && fleet.vpn">VPN</router-link>
        <a :href="`/api/heartbeat/${id}`" target="_blank" v-if="fleet && !fleet.restricted">API</a>
        <a :href="`/admin/web/locomotive/${id}/change/`" v-if="user && user.is_staff" target="_default">Admin</a>
      </div>
    </template>
  </sticky-bar>
  <div class="content">
      <router-view />
  </div>
</div></template>
<script>
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import StickyBar from './StickyBar'
export default {
  name: 'unit-details',
  props: ['id'],
  components: { StickyBar },
  computed: {
    unit() { return this.$store.state.units[this.id] },
    user() { return this.$store.state.user },
    fleet() { return this.$store.getters.unit_fleet[this.id] },
  },
  mounted() {
    this.$store.commit('selectUnit', this.id)
  },
  destroyed() {
    this.$store.commit('selectUnit', null)
  },
  watch: {
    id(nv) {
      this.$store.commit('selectUnit', nv)
    },
  },
}
</script>
<style lang="scss" scoped>

.main {
  .more-menu a {
    width: 65px;
  }
}

</style>
